export let Subfolder;
(function (Subfolder) {
  Subfolder["Deutch"] = "de";
  Subfolder["Japanese"] = "ja";
  Subfolder["Spanish"] = "es";
  Subfolder["French"] = "fr";
  Subfolder["Portuguese"] = "pt";
})(Subfolder || (Subfolder = {}));